/* ==========================================================================
   Solid Viibe — mixed 12-pack builder
   Stepper state + hard gate: add-to-cart stays disabled until the split is
   exactly 12 cans. Becomes `assets/mixed-pack.js` in the Shopify theme.
   ========================================================================== */
(function () {
  'use strict';

  document.querySelectorAll('[data-mixed-pack]').forEach(function (root) {
    var target = parseInt(root.dataset.mpTarget, 10) || 12;
    var rows = Array.prototype.slice.call(root.querySelectorAll('[data-mp-row]'));
    var countEl = root.querySelector('[data-mp-count]');
    var barEl = root.querySelector('[data-mp-bar]');
    var statusEl = root.querySelector('[data-mp-status]');
    var submit = root.querySelector('[data-mp-submit]');
    var variantId = parseInt(root.dataset.mpVariantId, 10);
    if (!rows.length || !submit) return;

    function total() {
      return rows.reduce(function (sum, row) {
        return sum + (parseInt(row.querySelector('[data-mp-value]').value, 10) || 0);
      }, 0);
    }

    function render() {
      var n = total();
      var remaining = target - n;
      var currentSplit = rows.map(function (row) {
        return String(parseInt(row.querySelector('[data-mp-value]').value, 10) || 0);
      }).join(',');

      root.querySelectorAll('[data-mp-preset]').forEach(function (button) {
        var selected = button.dataset.mpPreset.split(',').map(Number).join(',') === currentSplit;
        button.setAttribute('aria-pressed', String(selected));
      });

      if (countEl) countEl.textContent = String(n);
      if (barEl) {
        barEl.style.setProperty('--mp-progress', Math.min(n / target, 1));
        barEl.setAttribute('aria-valuenow', String(n));
      }

      if (statusEl && !variantId) {
        statusEl.textContent = 'Choose the mixed-pack product in the Theme Editor to enable ordering.';
      } else if (statusEl) {
        statusEl.textContent =
          remaining > 0 ? 'Add ' + remaining + ' more ' + (remaining === 1 ? 'can' : 'cans') + ' to complete your ' + target + '-pack.'
          : remaining < 0 ? 'Remove ' + (-remaining) + ' ' + (remaining === -1 ? 'can' : 'cans') + ' — a pack holds exactly ' + target + '.'
          /* Readiness only. The price is stated once, by the total above this
             line — repeating it here and again on the button read as chaos. */
          : 'Your ' + target + '-pack is ready.';
      }

      submit.disabled = n !== target || !variantId;
      root.dataset.mpComplete = String(n === target && Boolean(variantId));

      rows.forEach(function (row) {
        var value = parseInt(row.querySelector('[data-mp-value]').value, 10) || 0;
        var minus = row.querySelector('[data-mp-step="-1"]');
        var plus = row.querySelector('[data-mp-step="1"]');
        if (minus) minus.disabled = value <= 0;
        if (plus) plus.disabled = n >= target;
        row.dataset.mpActive = String(value > 0);
      });
    }

    rows.forEach(function (row) {
      var input = row.querySelector('[data-mp-value]');

      row.querySelectorAll('[data-mp-step]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var delta = parseInt(btn.dataset.mpStep, 10);
          var next = (parseInt(input.value, 10) || 0) + delta;
          if (next < 0) next = 0;
          if (delta > 0 && total() >= target) return;
          input.value = String(next);
          render();
        });
      });

      input.addEventListener('change', function () {
        var v = parseInt(input.value, 10);
        if (isNaN(v) || v < 0) v = 0;
        if (v > target) v = target;
        input.value = String(v);
        render();
      });
    });

    root.querySelectorAll('[data-mp-preset]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var split = btn.dataset.mpPreset.split(',').map(Number);
        rows.forEach(function (row, i) {
          row.querySelector('[data-mp-value]').value = String(split[i] || 0);
        });
        render();
      });
    });

    submit.addEventListener('click', function () {
      if (total() !== target || !variantId || !window.SolidViibe || !window.SolidViibe.cart) return;
      var original = submit.textContent;
      var properties = {};
      rows.forEach(function (row) {
        var quantity = parseInt(row.querySelector('[data-mp-value]').value, 10) || 0;
        properties[row.dataset.mpFlavour] = quantity + (quantity === 1 ? ' can' : ' cans');
      });
      properties['Pack size'] = target + ' cans';

      submit.disabled = true;
      submit.textContent = 'Adding…';
      window.SolidViibe.cart.add({
        id: variantId,
        quantity: 1,
        properties: properties
      }).then(function () {
        submit.textContent = 'Added to cart';
      }).catch(function (error) {
        submit.textContent = error.message || 'Could not add';
      }).finally(function () {
        window.setTimeout(function () {
          submit.textContent = original;
          render();
        }, 1600);
      });
    });

    render();
  });
})();
